import apiClient from './client'
import type { PricingDetail } from './orders'

export interface TimeSlot {
  time: string
  direction: 'go' | 'return'
}

export interface BatchOrderTemplate {
  id: string
  name: string
  order_category: string
  pickup_location: string
  dropoff_location: string
  vehicle_type: string
  passenger_count: number
  time_slots: TimeSlot[]
  weekdays: number[]
  default_weeks: number
  payment_method?: string
  pricing_template?: Partial<PricingDetail>
  driver_id?: string
  created_at: string
  updated_at: string
}

export type BatchOrderTemplateInput = Omit<BatchOrderTemplate, 'id' | 'created_at' | 'updated_at'>

export interface BatchOrderRun {
  id: string
  template_id?: string
  date_from: string
  date_to: string
  order_count: number
  order_ids: string[]
  created_by?: string
  created_at: string
}

export const batchOrderApi = {
  listTemplates: async (): Promise<BatchOrderTemplate[]> => {
    const r = await apiClient.get<BatchOrderTemplate[]>('/batch-orders/templates')
    return r.data
  },
  createTemplate: async (data: BatchOrderTemplateInput): Promise<BatchOrderTemplate> => {
    const r = await apiClient.post<BatchOrderTemplate>('/batch-orders/templates', data)
    return r.data
  },
  updateTemplate: async (id: string, data: BatchOrderTemplateInput): Promise<BatchOrderTemplate> => {
    const r = await apiClient.put<BatchOrderTemplate>(`/batch-orders/templates/${id}`, data)
    return r.data
  },
  deleteTemplate: async (id: string): Promise<void> => {
    await apiClient.delete(`/batch-orders/templates/${id}`)
  },
  listRuns: async (): Promise<BatchOrderRun[]> => {
    const r = await apiClient.get<BatchOrderRun[]>('/batch-orders/runs')
    return r.data
  },
  createRun: async (data: { template_id?: string; date_from: string; date_to: string; order_ids: string[] }): Promise<BatchOrderRun> => {
    const r = await apiClient.post<BatchOrderRun>('/batch-orders/runs', data)
    return r.data
  },
}
